// The one test of a finger-driven pointer (`ui-map-interface.md` §12). It
// is a leaf with no import, so a page boot module, the fault report and a
// lab may all ask it.

/** The media query of a finger-driven pointer. */
export const COARSE_QUERY = '(pointer: coarse)';

/** True on a finger-driven pointer, read at the call. A page with no
 *  `matchMedia` answers false. */
export function coarsePointer(): boolean {
  return typeof matchMedia === 'function' && matchMedia(COARSE_QUERY).matches;
}
